import React from "react";

const BASE_WIDTH = 424;
const BASE_HEIGHT = 209;

interface OwnProps {
  width?: number;
  height?: number;
  color?: string;
}
export default function EmptyTableIcon(props: OwnProps) {
  const width = props.width || BASE_WIDTH;
  const height = props.height || BASE_HEIGHT;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M211.941 203.469C326.71 203.469 419.749 188.18 419.749 169.319C419.749 150.458 326.71 135.168 211.941 135.168C97.1723 135.168 4.13361 150.458 4.13361 169.319C4.13361 188.18 97.1723 203.469 211.941 203.469Z"
        fill="#E5F4FF"
      />
      <path
        d="M371.251 169.319C371.251 182.123 342.395 189.817 204.091 189.817C77.9882 189.817 46.9733 182.123 46.9733 169.319C46.9733 156.515 112.57 146.135 204.091 146.135C295.612 146.135 371.251 156.515 371.251 169.319Z"
        fill="#CFEAFD"
      />
      <path
        d="M82.3633 165.371C82.3633 158.202 92.8772 129.527 198.016 129.527C324.183 129.527 355.724 158.202 355.724 165.371C355.724 172.539 355.724 179.708 208.53 179.708C82.3633 179.708 82.3633 172.539 82.3633 165.371Z"
        fill="#B5D7F1"
      />
      <path
        d="M62.8074 67.4998C80.2761 67.4998 94.4372 53.3426 94.4372 35.8788C94.4372 18.415 80.2761 4.25781 62.8074 4.25781C45.3388 4.25781 31.1776 18.415 31.1776 35.8788C31.1776 53.3426 45.3388 67.4998 62.8074 67.4998Z"
        fill="#CFEAFD"
      />
      <path
        d="M62.8069 61.1756C76.7818 61.1756 88.1107 49.8499 88.1107 35.8788C88.1107 21.9078 76.7818 10.582 62.8069 10.582C48.8319 10.582 37.503 21.9078 37.503 35.8788C37.503 49.8499 48.8319 61.1756 62.8069 61.1756Z"
        fill="#B5D7F1"
      />
      <path
        d="M328.313 87.1618C327.862 80.421 326.848 73.7297 325.282 67.1578C323.815 60.9329 321.879 54.8278 319.492 48.8946C317.311 43.522 315.593 40.4512 315.593 40.4512L300.651 42.377C300.651 42.377 302.374 45.9741 304.243 53.0238C305.001 55.8864 305.776 59.3274 306.476 63.3409C307.457 68.982 308.12 74.674 308.46 80.3897C308.599 82.5294 308.697 84.7618 308.767 87.0866C308.79 87.9309 308.83 88.7463 308.842 89.6138C308.882 92.3261 308.691 95.0847 308.356 97.8375C308.049 100.318 307.604 102.788 307.066 105.234C306.305 108.688 305.381 112.104 304.295 115.47C303.433 118.131 302.513 120.681 301.588 123.081C300.31 126.368 298.947 129.622 297.498 132.837C295.427 137.452 293.9 140.529 293.9 141.171C293.9 143.201 295.346 146.994 305.469 149.522C321.296 153.477 322.824 146.954 322.824 146.954C322.824 146.954 323.83 143.9 324.999 137.892C325.577 134.925 326.19 131.258 326.751 126.817C327.087 124.162 327.399 121.242 327.665 118.067C328.232 111.377 328.535 104.667 328.574 97.9531C328.585 96.9353 328.608 95.9522 328.608 94.9054C328.608 92.2509 328.487 89.6832 328.313 87.1618Z"
        fill="#73D2E6"
      />
      <path
        d="M372.279 20.5203C372.093 20.2774 353.756 -4.24894 329.975 6.50774C319.29 11.3367 312.4 19.2307 309.907 29.4264C305.256 22.9204 298.187 18.7912 288.828 17.1256C263.253 12.5685 247.802 40.9696 247.652 41.253C247.54 41.4541 247.501 41.6874 247.54 41.914C247.58 42.1405 247.696 42.3467 247.869 42.4982C248.042 42.6496 248.262 42.7372 248.492 42.7464C248.722 42.7555 248.948 42.6856 249.132 42.5484C249.248 42.4617 260.916 34.2958 280.347 37.7599C291.724 39.7556 303.037 42.1027 314.269 44.798C314.446 44.8414 314.632 44.8369 314.806 44.7851C314.981 44.7332 315.139 44.6359 315.264 44.5031C315.391 44.3643 328.586 30.1898 340.717 24.7073C358.673 16.5878 370.919 21.9777 371.029 22.0355C371.233 22.1271 371.461 22.1492 371.678 22.0985C371.896 22.0478 372.09 21.927 372.232 21.7548C372.374 21.5826 372.456 21.3684 372.464 21.1454C372.473 20.9223 372.407 20.7027 372.279 20.5203Z"
        fill="#7DDDF2"
      />
      <path
        d="M352.493 34.7322C334.364 25.1611 320.272 29.9264 311.52 35.7385C301.032 33.7086 281.433 33.6739 264.825 54.9617C244.434 81.09 262.32 113.672 262.5 114.002C262.679 114.326 263.02 114.517 263.385 114.517L263.506 114.511C263.705 114.486 263.893 114.402 264.044 114.27C264.195 114.138 264.304 113.964 264.357 113.771C264.42 113.545 270.703 90.8289 286.587 71.7271C295.27 61.2885 305.637 51.6364 312.931 45.2807C320.278 46.5009 331.072 49.2017 341.676 55.1236C362.345 66.6784 371.826 86.2312 371.919 86.4279C372.104 86.8096 372.503 87.0756 372.942 87.0004C373.151 86.9789 373.347 86.8925 373.504 86.7535C373.661 86.6145 373.77 86.4298 373.816 86.2255C373.897 85.8611 381.868 50.2426 352.493 34.7322Z"
        fill="#90DEEF"
      />
      <path
        d="M92.0707 27.0149C92.5562 26.9534 92.9246 26.6363 93.0015 26.2404C94.2386 19.8655 99.5114 14.2676 107.271 12.0729L107.279 12.0705C107.621 11.974 107.895 11.7462 107.993 11.4535C108.173 10.9156 107.786 10.4021 107.193 10.2807C104.723 9.77501 102.06 9.83149 99.4723 10.5635C94.615 11.9374 91.2432 15.3445 90.2404 19.2874C90.1741 19.5477 90.0012 19.786 89.7327 19.9257C89.3084 20.1464 88.7809 20.1005 88.4209 19.8361C84.8054 17.1807 79.6663 16.1656 74.7939 17.5437C72.2184 18.2722 70.061 19.5723 68.4528 21.2208C68.1619 21.519 68.094 21.9399 68.313 22.2791C68.5722 22.6806 69.1302 22.8611 69.6329 22.7185C69.6373 22.7173 69.6417 22.716 69.6462 22.7148C77.3936 20.5235 85.5831 22.3009 91.1186 26.7449C91.3735 26.9495 91.7229 27.059 92.0707 27.0149Z"
        fill="#91BCDD"
      />
      <path
        d="M139.065 20.6149C137.121 20.1446 134.99 20.0846 132.88 20.5294C128.908 21.367 126.012 23.7821 124.992 26.6857C124.908 26.9235 124.671 27.1088 124.367 27.1727C124.064 27.2366 123.74 27.1692 123.516 26.9962C120.781 24.8847 116.735 23.9337 112.763 24.7712C110.653 25.216 108.847 26.1059 107.465 27.2776C107.197 27.5042 107.153 27.8423 107.356 28.1068C107.559 28.3713 107.961 28.4989 108.341 28.4186C108.345 28.4179 108.348 28.4171 108.352 28.4164C114.677 27.0827 121.127 28.7241 125.292 32.2493C125.515 32.4384 125.854 32.5149 126.171 32.4482C126.488 32.3814 126.733 32.1823 126.806 31.9307C128.162 27.2411 132.697 23.2833 139.023 21.9495C139.027 21.9488 139.03 21.948 139.034 21.9473C139.414 21.8673 139.681 21.5993 139.688 21.2903C139.695 20.9812 139.441 20.7059 139.065 20.6149Z"
        fill="#91BCDD"
      />
      <ellipse
        cx="151.41"
        cy="89.6423"
        rx="5.13228"
        ry="2.38645"
        fill="#06C5EF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M156.542 89.6421H146.277C146.278 88.3242 148.575 87.2559 151.41 87.2559C154.244 87.2559 156.542 88.3242 156.542 89.6421Z"
        fill="#47DDFE"
      />
      <rect
        x="151.536"
        y="77.0215"
        width="15.2775"
        height="33.6489"
        rx="7.63875"
        fill="#E5F7FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M158.528 118.82C157.905 118.82 157.4 119.325 157.4 119.948V129.85H156.397C155.844 129.85 155.395 130.299 155.395 130.853C155.395 131.407 155.844 131.856 156.397 131.856H158.653C159.207 131.856 159.656 131.407 159.656 130.853C159.656 130.834 159.656 130.814 159.654 130.795C159.656 130.773 159.656 130.75 159.656 130.727V119.948C159.656 119.325 159.151 118.82 158.528 118.82Z"
        fill="#0ED4FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M164.452 118.82C163.829 118.82 163.324 119.325 163.324 119.948V129.85H162.321C161.768 129.85 161.319 130.299 161.319 130.853C161.319 131.407 161.768 131.856 162.321 131.856H164.577C165.131 131.856 165.58 131.407 165.58 130.853C165.58 130.834 165.58 130.814 165.578 130.795C165.58 130.773 165.58 130.75 165.58 130.727V119.948C165.58 119.325 165.075 118.82 164.452 118.82Z"
        fill="#0ED4FF"
      />
      <path
        d="M150.226 103.011C151.668 100.57 151.936 96.7244 151.89 95.1066V90.8076C151.89 84.8447 151.474 83.5967 152.722 81.2393C153.72 79.3533 155.727 78.1423 156.605 77.7726C157.714 77.2179 160.682 76.5522 163.677 78.3273C166.672 80.1023 167.329 83.7817 167.283 85.3995V90.1144C167.283 94.2191 169.316 97.1867 170.333 98.1574C173.551 101.375 174.262 106.431 174.216 108.558C174.216 118.986 176.342 124.366 177.406 125.753C176.111 125.892 171.692 126.086 164.37 125.753C157.049 125.42 151.89 117.479 150.226 113.55C148.673 108.669 149.579 104.49 150.226 103.011Z"
        fill="#E5F7FF"
      />
      <path
        d="M162.428 78.8835C163.513 78.5218 163.465 77.6179 163.118 77.252H156.385C155.772 77.4968 155.938 78.6141 156.881 78.8835C157.852 79.1609 158.684 79.1609 159.793 79.1609H159.793C160.902 79.1609 161.596 79.1609 162.428 78.8835Z"
        fill="#3CACEB"
      />
      <path
        d="M156.173 76.0028C156.626 76.1509 157.648 76.4037 159.342 76.4037C161.035 76.4037 162.058 76.1509 162.511 76.0028C162.648 75.9581 162.789 76.06 162.789 76.2044L162.789 77.1296C162.361 77.338 161.81 77.4817 161.275 77.5804C159.997 77.8162 158.686 77.8162 157.409 77.5804C156.874 77.4817 156.323 77.338 155.894 77.1296L155.894 76.2044C155.894 76.06 156.035 75.9581 156.173 76.0028Z"
        fill="#6BC3F4"
      />
      <path
        d="M160.942 71.9998C159.897 71.6876 158.783 71.6876 157.737 71.9998C155.56 72.6496 152.327 74.9873 155.892 76.5024C156.961 76.9288 159.837 77.5258 162.787 76.5024C166.353 74.9873 163.119 72.6496 160.942 71.9998Z"
        fill="#E5F7FF"
      />
      <path
        d="M169.112 119.768L179.374 124.309L179.373 124.312C176.123 126.306 174.74 127.106 171.82 126.3C168.901 125.494 168.278 125 167.138 124.227C165.998 123.455 165.364 122.25 165.909 121.019L165.91 121.016C166.455 119.786 167.889 119.227 169.112 119.768Z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M161.735 94.5528C165.165 94.5643 169.039 96.4941 169.917 97.6035C173.661 101.348 174.308 105.97 174.216 107.588C174.216 117.129 175.695 122.426 176.435 123.951C169.113 123.951 164.694 120.531 163.4 118.82C150.642 103.955 152.236 94.5209 161.735 94.5528Z"
        fill="#64BDEF"
      />
      <path
        d="M169.105 118.931L177.822 125.998L177.82 126C174.162 127.074 172.617 127.485 170.01 125.943C167.403 124.402 166.931 123.762 166.032 122.719C165.134 121.675 164.838 120.346 165.686 119.3L165.688 119.298C166.536 118.253 168.066 118.088 169.105 118.931Z"
        fill="#E5F7FF"
      />
      <path
        d="M166.957 119.224L174.365 127.652L174.363 127.653C170.576 128.1 168.984 128.245 166.673 126.289C164.362 124.332 164.003 123.622 163.293 122.443C162.582 121.264 162.513 119.904 163.525 119.015L163.526 119.014C164.538 118.125 166.074 118.219 166.957 119.224Z"
        fill="url(#paint1_linear)"
      />
      <path
        d="M159.794 94.6908C163.816 94.4137 166.181 97.6027 166.728 98.4349C169.917 103.286 167.653 108.052 167.56 109.67C167.56 119.21 171.978 123.539 172.717 125.065C162.706 126.865 160.187 125.065 157.021 122.707C144.54 113.414 148.562 95.465 159.794 94.6908Z"
        fill="#64BDEF"
      />
      <path
        d="M168.854 135.822C169.17 135.744 169.525 135.683 169.923 135.641L165.458 133.08H164.455C163.902 133.08 162.975 132.806 162.386 132.468C161.796 132.129 161.768 131.855 162.321 131.855H164.577C165.131 131.855 166.058 132.129 166.647 132.468C166.669 132.48 166.69 132.492 166.71 132.505C166.734 132.518 166.757 132.531 166.781 132.544L172.018 135.548C172.205 135.544 172.39 135.539 172.573 135.535C172.581 135.388 172.602 135.228 172.635 135.052C172.865 133.854 174.616 133.943 178.888 134.216L178.892 134.217L179.024 134.653C180.225 134.701 181.861 134.921 184.119 135.229L184.123 135.23L184.048 135.502C185.031 135.709 186.16 135.964 187.476 136.262L187.479 136.263L185.528 137.26C186.263 137.88 187.274 138.658 188.622 139.604C191.042 141.274 194.716 143.615 200.038 146.668C201.852 147.656 206.123 150.477 206.363 152.763C206.396 152.835 206.404 152.913 206.388 152.995C206.866 153.858 208.301 155.386 211.696 157.333L216.713 160.211C217.372 160.579 218.239 161.123 219.009 161.715C219.178 161.844 219.335 161.97 219.478 162.094C220.533 162.988 221.24 163.933 220.633 164.528C220.586 164.574 220.535 164.617 220.479 164.657C220.891 164.84 221.144 165.026 221.208 165.147L221.863 165.523C227.051 166.45 226.304 167.881 224.815 168.278C224.1 168.469 222.983 168.469 221.602 168.278C218.727 167.881 212.991 166.45 214.949 165.523L214.95 165.522L214.288 165.143C213.917 165.049 213.545 164.876 213.304 164.7C212.973 164.63 212.594 164.546 212.178 164.447C211.87 164.374 211.56 164.297 211.249 164.216C209.839 163.853 208.169 163.359 206.579 162.75C203.695 161.645 202.487 160.94 199.209 159.023L199.069 158.941C199.04 158.941 199.011 158.942 198.983 158.942C196.148 158.942 192.714 158.291 191.302 157.487L191.291 157.48C189.884 156.674 191.048 156.02 193.889 156.02C193.931 156.02 193.973 156.02 194.015 156.02L190.196 153.83C188.95 153.131 187.049 152.126 184.954 151.156C179.787 149.233 174.756 146.718 171.264 144.213C170.72 143.828 170.196 143.432 169.702 143.028C169.637 142.966 169.571 142.903 169.506 142.837C167.212 140.861 166.059 138.96 166.754 137.439C166.756 137.434 166.758 137.43 166.76 137.425C166.776 137.369 166.795 137.313 166.817 137.258L159.532 133.08H158.53C157.976 133.08 157.049 132.806 156.46 132.468C155.871 132.129 155.842 131.855 156.396 131.855H158.652C159.206 131.855 160.132 132.129 160.722 132.468C160.743 132.48 160.764 132.492 160.785 132.505C160.808 132.518 160.832 132.531 160.855 132.544L167.52 136.367C167.815 136.147 168.23 135.961 168.854 135.822Z"
        fill="#393939"
        fillOpacity="0.25"
      />
      <defs>
        <filter
          id="filter0_d"
          x="-4"
          y="-3"
          width="432"
          height="216"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear"
          x1="165.886"
          y1="121.148"
          x2="180.265"
          y2="124.178"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EBF9FF" />
          <stop offset="1" stopColor="#F4FCFF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="163.449"
          y1="119.123"
          x2="175.227"
          y2="127.908"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EBF9FF" />
          <stop offset="1" stopColor="#F4FCFF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
